import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dp-detail-info',
  templateUrl: './dp-detail-info.component.html',
  styleUrls: ['./dp-detail-info.component.scss']
})
export class DpDetailInfoComponent implements OnInit {
  @Input()
  title: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
